<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import setRem from './libs/rem.js'

export default {
  components: {},
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0)
    }
  },
  data() {
    return {
      router: null
    }
  },
  created() {
  },
  mounted() {
    setRem()
    window.addEventListener("resize", setRem)
  },
  methods: {
  }
}
</script>
<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
  padding-top: 79px;
}
i {
  font-size: 16px!important;
}
.el-popup-parent--hidden {
  padding-right: 0!important;
}
::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
  background-color: #008b3f;
}

::-webkit-scrollbar-thumb:window-inactive {
  background-color: #008b3f;
}

::-webkit-scrollbar-thumb:vertical:hover {
  background-color: #008b3f;
}
</style>
